import {useMemo} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import ClinicPositionsLayout from '@/src/jobPortal/clinicPositions/components/СlinicPositionsLayout';
import useClinicPositions from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';

const ClinicPositions = () => {
  const {filter, isLoading, ...data} = useClinicPositions();

  const activeFilterStatus = useMemo(
    // eslint-disable-next-line no-eval
    () => eval(filter[SEARCH_FILTERS.FILTERS_STATUS])[0],
    [filter[SEARCH_FILTERS.FILTERS_STATUS]]
  );

  return (
    <ClinicPositionsLayout
      filter={filter}
      isLoading={isLoading}
      isActiveHeaderAddButton={Boolean(data[activeFilterStatus]?.data?.length)}
    />
  );
};

export default ClinicPositions;
